"use strict";
var EmptyObservable_1 = require('./EmptyObservable');
exports.empty = EmptyObservable_1.EmptyObservable.create;
//# sourceMappingURL=empty.js.map


//////////////////
// WEBPACK FOOTER
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/~/rxjs/observable/empty.js
// module id = slZm
// module chunks = 5